module.exports = __webpack_public_path__ + "6c96fb010f698ab8600a5b2324fc9018.svg";